import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICardScalarProps } from "./CardScalar"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import { useEffect, useState } from "react"
import { CARD_FIELD_TYPE, LANDING_TYPE_CONTENT } from "../../data/interfaces"
import { PersonsFieldType } from "../../views/landing/contentType/Persons"
import { Button, ButtonGroup, ButtonVariant, Callout, Icon, Intent, Popover, Position, Size } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"

/* Protopia Ecosystem component */
export interface ICardsOrderScalarProps extends ICardScalarProps {
   
}
const CardsOrderScalar = (props: ICardsOrderScalarProps): JSX.Element => {
    return <>
        <Scalar  
            value={ props.value }
            editable={props.editable }
            field={props.field}
            subtitle={props.title}
            title={ " " }
            notClear
            rowClassName="width-auto"
            vertical={ VerticalType.HORIZONTAL }
            enabledForm={ <CardsOrderEnabled {...props} /> }  
            desabledForm={ <CardsOrderDisable {...props} /> }  
            commentary={props.commentary }
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}  
            onChange={props.onChange}
        />
    </>
}
export default CardsOrderScalar

export const CardsOrderEnabled = (props:ICardsOrderScalarProps): JSX.Element => {
    const [value, setValue]             = useState<string[]>( props.value || [] ) 
    const [fieldTypes, setFieldTypes]   = useState<string[]>([])
    
    useEffect(() => {
        setFieldTypes( getAllFieldTypes( props.origin?.type || LANDING_TYPE_CONTENT.CARDS ) )
    }, [props.origin])

    useEffect(() => {
        setValue( props.value || [] )
    }, [props.value])
    
    console.log( props )

    const onChange = (value: string[]) => {
        setValue(value)
        if(props.onChange) {
            props.onChange( value, props.field, "" )
        }
    }
    const onTrash = ( key: string ) => {
        onChange(value.filter( v => v !== key ) )
    }
    const onAdd = ( key: string ) => {
        onChange([...value, key ])
    }
    
    // a little function to help us with reordering the result
    const reorder = (list: any[], startIndex: number, endIndex: number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed); 
        return result;
    }; 

    const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({ 
        userSelect: "none",
        padding: 0, 
        margin: `0 0 0 0`, 
        width: "100%",
        // change background colour if dragging
        background: isDragging ? "#a4bcf0" : "transparent", 
        color: isDragging ? "#d1ddf5" : undefined, 
        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = (isDraggingOver: boolean) => ({
        background: isDraggingOver ? "#8885b4cc" : "transparent",
        color: isDraggingOver ? "#5e7092" : undefined, 
        padding: 0, 
    })
    const onDragEnd = (result: any) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        } 
        const _items: any[] = reorder(
            value,
            result.source.index,
            result.destination.index
        ); 
        onChange(_items )
    }

    return <div className="w-100 mb-3 px-3 max-width-400 w-100"> 
        <DragDropContext onDragEnd={ onDragEnd }>
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        { 
                            value.map((key: string, index: number) => {
                                return <div key={key} className="d-flex"> 
                                    <Draggable draggableId={ key } index={ index }>
                                        {(provided, snapshot) => ( 
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}
                                            > 
                                                <Button fill variant={ ButtonVariant.MINIMAL } size={ Size.LARGE } alignText={ "left" } className="p-0 btn-stretch " >
                                                    <div className="w-100 d-flex align-items-center justify-content-between py-2">
                                                        <div className="smaller text-uppercase letter-spacing-2 px-2">
                                                            <Icon icon="drag-handle-vertical" className="mr-1"/>
                                                            { __( key ) }
                                                        </div>
                                                        <div className="pe-surface ">
                                                            <Popover
                                                                position={ Position.LEFT }
                                                                content={ <CardFieldHandler fieldTypes={ fieldTypes } value={ value } onChoose={ onAdd } /> }
                                                                interactionKind="hover"
                                                            >
                                                                <Button size="small" variant={ ButtonVariant.MINIMAL } icon="plus"  className="px-2 py-1 mr-1" intent={ Intent.NONE } />
                                                            </Popover>                            
                                                            <Button size="small" variant={ ButtonVariant.SOLID }   icon="trash" className="px-2 py-1" intent={ Intent.DANGER } onClick={ ()=> onTrash(key) } /> 
                                                        </div> 
                                                    </div>
                                                </Button>
                                            </div>
                                        )}
                                    </Draggable>
                                </div>
                            })
                        }
                    </div>
                )}
            </Droppable >
        </DragDropContext>
    </div>
}
export const CardsOrderDisable = (props:ICardsOrderScalarProps): JSX.Element => {
    return <>Cards Order Disable</>
}


export function getAllFieldTypes(type: string): string[] {
    switch(type) {
        case LANDING_TYPE_CONTENT.CARDS:
            return Object.values( CARD_FIELD_TYPE )
        case LANDING_TYPE_CONTENT.PERSONAL_CARDS:
            return Object.keys( PersonsFieldType() )
        default:
            return[]
    }
}


export const CardFieldHandler = ({fieldTypes, value, onChoose}: any) : JSX.Element => {
    
    console.log( fieldTypes )
    
    return <ButtonGroup fill vertical>
        <Callout className="p-3">
            {
                __("Add field after this")
            }
        </Callout>
        {
            fieldTypes
            .filter( ( field:string ) => !value.includes( field ) )
            .map( ( field:string ) => {
                return <Button key={ field }  variant={ ButtonVariant.MINIMAL } alignText={ "left" } onClick={ () => onChoose( field ) } className="width-300 py-1">
                    <div className="text-uppercase letter-spacing-2 smaller"> 
                        {__( field ) }
                    </div>
                </Button>
            })
        }
    </ButtonGroup>
}